import { List, Create, Edit } from "../Components/index.js";

export default [
    {
        path: "/admin/district/:upazila_id/post-office",
        component: List,
        name: "post-office-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/district/:upazila_id/post-office/:id/edit",
        component: Edit,
        name: "post-office-edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/district/:upazila_id/post-office/create",
        component: Create,
        name: "post-office-create",
        meta: {
            requiresAuth: true,
        },
    },
];
